/** Pages reachable from the Giving Wallet card (they act as the acting entity, like the wallet). */
export const WALLET_LINKS = [
  { to: '/web/wallet/send', label: 'Send money' },
  { to: '/web/wallet/requests', label: 'Money requests sent' },
  { to: '/web/wallet/donations', label: 'Donations' },
  { to: '/web/wallet/recurring', label: 'Recurring donations' },
  { to: '/web/wallet/receipts', label: 'Receipts' },
  { to: '/web/wallet/mailing-address', label: 'Mailing address' },
];
